import TuneIcon from "@mui/icons-material/Tune";
import styled from "styled-components";
import { GridViewSharp, ListSharp } from "@mui/icons-material";
import useIsMobile from "../../../helpers/isMobile";
import { useState } from "react";
import { FilterPanel } from "./filter-panel/FilterPanel";

export const SpanFilter = styled.span`
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--bs-secondary);
    padding-left: 3%;
`

export const ContainerBtn = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;

    .activeTab {
        background: var(--bs-primary);
        color: white;
    }
`

export const AccessStyle = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.5rem;
    background: none;
    color: var(--bs-primary);
    border: none;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.7;
    }

    &.activeTab {
        background: var(--bs-primary);
        color: white;
        border-radius: 0.25rem;
    }
`

export const ViewLabel = styled.span`
    font-size: 0.7rem;
    font-weight: 500;
    white-space: nowrap;
`

export const FilterSection = ({ filterOptions, filter, viewMode, onFilterChange, onViewModeChange }) => {
    const isTablet = useIsMobile().isTablet;
    const [hide, setHide] = useState(isTablet);

    return (
        <div>
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <div className="d-flex">
                    <TuneIcon style={{ color: 'var(--bs-secondary)' }} />
                    <SpanFilter>Filtros</SpanFilter>
                    {isTablet && (
                        <div className="form-check form-switch ms-2">
                            <input className="form-check-input" type="checkbox" role="switch" id="filterSwitch"
                                checked={!hide} onChange={() => setHide(!hide)} />
                        </div>
                    )}
                </div>

                <ContainerBtn>
                    <AccessStyle
                        title="Vista en cuadrícula"
                        id="grid"
                        onClick={() => onViewModeChange('grid')}
                        className={`tab-button ${viewMode === 'grid' ? 'activeTab' : ''}`}>
                        <GridViewSharp style={{ fontSize: 28 }} />
                        <ViewLabel>Cuadrícula</ViewLabel>
                    </AccessStyle>
                    <AccessStyle
                        title="Vista en lista"
                        id="list"
                        onClick={() => onViewModeChange('list')}
                        className={`tab-button ${viewMode === 'list' ? 'activeTab' : ''}`}>
                        <ListSharp style={{ fontSize: 28 }} />
                        <ViewLabel>Lista</ViewLabel>
                    </AccessStyle>
                </ContainerBtn>
            </div>

            {!hide && <FilterPanel filterOptions={filterOptions} filter={filter} onFilterChange={onFilterChange} />}
        </div>
    );
};
